<p-toast position="{{smallScreen ? 'bottom-right' : 'top-right'}}"></p-toast>

<div class="p-fluid p-grid p-m-0" style="background: var(--indigo-700);min-height:100%">
  <div class="p-field p-md-offset-4 p-md-4">
    <p-card [style]="{'background': 'var(--surface-50)'}" [styleClass]="'p-shadow-12 p-mt-4 p-p-2 animate__animated animate__fadeIn'">
      <form *ngIf="section === 'profile'"
            #profileForm="ngForm" 
            (ngSubmit)="updateUserProfile(profileForm)">
        <div class="p-fluid p-grid">
          <h3 class="title title-left p-col-12 p-mt-0">
            User Profile
            <br/>
            <small class="p-error" *ngIf="!canManageProfile()">
              You don't have permission to update your profile
            </small>
          </h3>
          
          <div class="p-field p-col-12">
            <span class="p-float-label p-input-icon-right">
              <i class="pi pi-user"></i>
              <input type="text" id="firstname" name="firstname" pInputText 
                     required
                     #firstname="ngModel"
                     [disabled]="!canManageProfile()"
                     [(ngModel)]="updateAccountViewModel.firstName"
                     [class.field-error]="profileForm.submitted && firstname.hasError('required')">
              <label for="firstname" class="required-field">First Name</label>
            </span>
            <small class="p-error" *ngIf="profileForm.submitted && firstname.hasError('required')">First name is required</small>
          </div>

          <div class="p-field p-col-12">
            <span class="p-float-label p-input-icon-right">
              <i class="pi pi-user"></i>
              <input type="text" id="lastname" name="lastname" pInputText 
                     required
                     [disabled]="!canManageProfile()"
                     #lastname="ngModel"
                     [(ngModel)]="updateAccountViewModel.lastName"
                     [class.field-error]="profileForm.submitted && lastname.hasError('required')">
              <label for="lastname" class="required-field">Last Name</label>
            </span>
            <small class="p-error" *ngIf="profileForm.submitted && lastname.hasError('required')">Last name is required</small>
          </div>

          <div class="p-field p-col-12">
            <span class="p-float-label p-input-icon-right">
              <i class="pi pi-envelope"></i>
              <input type="text" id="email" name="email" pInputText 
                     required
                     [disabled]="!canManageProfile()"
                     #email="ngModel"
                     [(ngModel)]="updateAccountViewModel.email"
                     [class.field-error]="profileForm.submitted && email.hasError('required')">
              <label for="email" class="required-field">Email</label>
            </span>
            <small class="p-error" *ngIf="profileForm.submitted && email.hasError('required')">Email is required</small>
          </div>

          <div class="p-field p-mb-0 p-col-12 p-text-right">
            <div class="p-d-inline-block p-mr-1">
              <button pButton pRipple label="Update Profile" 
                      class="p-button p-button-raised p-button-danger" 
                      icon="pi pi-save" 
                      [disabled]="updating || !canManageProfile()"
                      type="submit"></button>
            </div>
          </div>          
        </div>
      </form>

      <form *ngIf="section === 'cred'"
            #credForm="ngForm" (ngSubmit)="updateCred(credForm)">
        <div class="p-fluid p-grid">
          <h3 class="title title-left p-col-12 p-mt-0">
            Password Change
            <div class="p-error p-pt-2 p-pb-2" *ngIf="errorMessage">{{errorMessage}}</div>
            <br/>
            <small class="p-error" *ngIf="!canManagePassword()">
              You don't have permission to update your password
            </small>
          </h3>
          
          <div class="p-field p-col-12">
            <label for="currentPassword">Current Password</label>
            <p-password id="currentPassword" name="currentPassword" class="p-inputtext-sm" [feedback]="false" [toggleMask]="true"
                        required
                        [disabled]="!canManagePassword()"
                        #currentPassword="ngModel"
                        [class.field-error]="credForm.submitted && currentPassword.invalid"
                        [(ngModel)]="updatePasswordViewModel.currentPassword"></p-password>
            <small class="p-error" *ngIf="credForm.submitted && currentPassword.hasError('required')">Must provide current password</small>
          </div>

          <div class="p-field p-col-12">
            <label for="newPassword">New Password</label>
            <p-password id="newPassword" name="newPassword" class="p-inputtext-sm" [toggleMask]="true"
                        required
                        [disabled]="!canManagePassword()"
                        minlength="8"
                        #newPassword="ngModel"
                        strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})(?=.*[-+_!@#$%^&*.,?])"
                        [class.field-error]="credForm.submitted && newPassword.invalid"
                        [(ngModel)]="updatePasswordViewModel.newPassword"></p-password>
            <small class="p-error" *ngIf="credForm.submitted && newPassword.hasError('required')">Password is required</small>
            <small class="p-error" *ngIf="credForm.submitted && newPassword.hasError('minlength')">Password too short</small>
            <small class="p-error" *ngIf="credForm.submitted && newPassword.hasError('notmatch')">Password not match</small>
            <small class="p-error" *ngIf="credForm.submitted && newPassword.hasError('nolowercase')">At lease one lower case is required</small>
            <small class="p-error" *ngIf="credForm.submitted && newPassword.hasError('nouppercase')">At least one upper case is required</small>
            <small class="p-error" *ngIf="credForm.submitted && newPassword.hasError('nodigit')">At least one digit is required</small>
            <small class="p-error" *ngIf="credForm.submitted && newPassword.hasError('nonalphanumeric')">At least one non-alphanumeric character is required: - + _ ! @ # $ % ^ & * . , ?</small>
            
          </div>

          <div class="p-field p-col-12">
            <label for="confirmPassword">Confirm Password</label>
            <p-password id="confirmPassword" name="confirmPassword" class="p-inputtext-sm" [toggleMask]="true"
                        #confirmPassword="ngModel"
                        [disabled]="!canManagePassword()"
                        strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})(?=.*[-+_!@#$%^&*.,?])"
                        [class.field-error]="credForm.submitted && confirmPassword.invalid"
                        [(ngModel)]="updatePasswordViewModel.confirmPassword"></p-password>
            <small class="p-error" *ngIf="credForm.submitted && confirmPassword.hasError('notmatch')">Password not match</small>
          </div>

          <div class="p-field p-col-12">
            <p class="p-mt-2">Suggestions</p>
            <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
              <li>At least one lowercase</li>
              <li>At least one uppercase</li>
              <li>At least one numeric</li>
              <li>At least one non-alphanumeric: <strong>- + _ ! @ # $ % ^ & * . , ?</strong></li>
              <li>Minimum 8 characters</li>
            </ul>
          </div>

          <div class="p-field p-mb-0 p-col-12 p-text-right">
            <div class="p-d-inline-block p-mr-1">
              <button pButton pRipple label="Update Password" 
                      [disabled]="!canManagePassword()"
                      class="p-button p-button-raised p-button-danger" icon="pi pi-save" type="submit"></button>
            </div>
          </div>          

        </div>
      </form>
    </p-card>
  </div>
</div>